<ng-container *ngIf="processos.length">
    <div *ngIf="minimized;else navbar" class="fixed-bottom" title="Ver processos em andamento">
        <i (click)="toggle()" class="fas fa-sync-alt fa-spin fa-lg m-2 pointer"></i>
    </div>
    <ng-template #navbar>
        <nav class="fixed-bottom navbar-light bg-light">
            <div class="d-flex">
                <button type="button" (click)="toggle()" class="close mx-4" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div class="d-flex flex-column w-100 pr-3">
                    <app-progresso class="mb-3 w-100" *ngFor="let p of processos" [situacao]="p.situacao" [posicaoAtual]="p.posicaoAtual" [totalRegistro]="p.totalRegistro"></app-progresso>
                </div>
            </div>
        </nav>
    </ng-template>
</ng-container>
<div *ngIf="notificador" class="notificador p-2 bg-secondary text-white animated" [ngClass]="classNotificador">
        {{msg}}
</div>
